import React from "react";

const RichContentImages = props => {
  return props.images.imageUris.map((uri, index) => /*#__PURE__*/React.createElement("div", {
    className: "image-entry"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Rich Content Descriptor",
    src: uri
  }), /*#__PURE__*/React.createElement("label", null, props.images.captions[index])));
};

export default RichContentImages;